import { api } from "@/utils/axios";

interface Authentication {
  type: string;
  name: string;
  mobile: string;
  email?: string;
  gender?: string;
  positive?: string;
  back?: string;
  id_card?: string;
  start_time?: string;
  end_time?: string;
}

export interface StaffRequestBody extends Authentication {
  department_name?: string;
  duty_name?: string;
  subgroup_name?: string;
  certificate?: any[];
}

export interface StoresRequestBody extends Authentication {
  stores_name: string;
  duty_name?: string;
  stores_type?: string;
  stores_sub?: string;
  license?: string;
  social_credit?: string;
  license_start_time?: string;
  license_end_time?: string;
  place_name?: string;
  owner_name?: string;
  contact_phone?: string;
}

export interface FactoryRequestBody extends Authentication {
  factory_name: string;
  certificate?: string;
  license?: string;
  social_credit?: string;
  license_start_time?: string;
  license_end_time?: string;
  province?: string;
  city?: string;
  county?: string;
  address?: string;
  contact_name?: string;
  contact_phone?: string;
}

export interface ResidenceRequestBody extends Authentication {
  house_json: any;
}

export interface CancelApplyBody {
  user_id?: string;
  state?: "3" | "4"; //3拒绝 4取消
  desc?: string;
}

export const userService = {
  getUserInfo() {
    return api.post<ResponseData>("/User/get_user_info");
  },
  getShopConfig() {
    return api.post<ResponseData>("/Mydb/shop_config");
  },
  getCertificateType() {
    return api.post<ResponseData<{ id: string; name: string }[]>>("/User/get_certificate_type");
  },
  authentication(body: StaffRequestBody | StoresRequestBody | FactoryRequestBody | ResidenceRequestBody) {
    return api.post<ResponseData>("/User/user_authentication", body);
  },
  authenticationDetail() {
    return api.post<ResponseData>("/User/authentication_detail");
  },
  cancelApply(body?: CancelApplyBody) {
    return api.post<ResponseData>("/User/cancel_apply", body);
  },
  userLists(body: any) {
    return api.post<ResponseData>("/User/user_lists", body);
  },
  userInfo(body: any) {
    return api.post<ResponseData>("/User/user_info", body);
  },
  del_house_user(body: any) {
    return api.post<ResponseData>("/User/del_house_user", body);
  },
  houseUser(body = {}) {
    return api.post<ResponseData>("/User/my_house_user", body);
  },
  check_user(body = {}) {
    console.log(body);
    return api.post<ResponseData>("/User/check_user", body);
  },
  user_info_change(body = {}) {
    return api.post<ResponseData>("/User/user_info_change", body);
  },
  my_shop_change(body = {}) {
    return api.post<ResponseData>("/User/my_shop_change", body);
  }
};
